import { useCallback, useState } from "react";

const download = (blob: Blob, fileName: string) => {
	const href = URL.createObjectURL(blob);
	const link = document.createElement("a");
	link.href = href;
	link.download = fileName;
	link.click();
	URL.revokeObjectURL(href);
};

/**
 * Runs one PDF export: the spinner while the API draws it, the download under a readable
 * name, and any error handed to the page's error modal.
 */
export const useReportPdfExport = (onError: (message: string) => void) => {
	const [exporting, setExporting] = useState(false);

	const exportPdf = useCallback(
		async (fileName: string, generate: () => Promise<Blob>) => {
			setExporting(true);
			try {
				download(await generate(), fileName);
			} catch (error) {
				onError((error as Error).message);
			} finally {
				setExporting(false);
			}
		},
		[onError],
	);

	return { exporting, exportPdf };
};
